import { CALL_API } from 'middleware/api';
import { createApiModule } from 'hooks';
const MODULE_NAME = 'Contacts';
const createApiModuleActions = createApiModule(MODULE_NAME);
const handleInfo = createApiModuleActions('HANDLE_INFO');
export const getHandleInfo = (handle) => ({
    [CALL_API]: {
        endpoint: `/user-handle/${handle}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: handleInfo,
    },
});
